import PropTypes from "prop-types"

const titleIsRequired = {
  title: PropTypes.string.isRequired,
}

const markdownIsRequired = {
  markdown: PropTypes.string.isRequired,
}

const imageProps = {
  name: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  markdown: PropTypes.string,
}

const imageIsRequired = {
  image: PropTypes.shape({
    ...imageProps,
  }).isRequired,
}

const indexIsRequired = {
  index: PropTypes.number.isRequired,
}

export const titleOnly = {
  data: PropTypes.shape({
    ...titleIsRequired,
  }).isRequired,
}

export const markdownOnly = {
  data: PropTypes.shape({
    ...markdownIsRequired,
  }).isRequired,
}

export const titleAndMarkdown = {
  data: PropTypes.shape({
    ...markdownIsRequired,
    ...titleIsRequired,
  }).isRequired,
}

export const imageAndMarkdown = {
  images: PropTypes.object.isRequired,
  data: PropTypes.shape({
    ...markdownIsRequired,
    ...imageIsRequired,
  }).isRequired,
}

export const titleMarkdownAndIndex = {
  data: PropTypes.shape({
    ...markdownIsRequired,
    ...titleIsRequired,
    ...indexIsRequired,
  }).isRequired,
}

export const portraitPropTypes = {
  data: PropTypes.shape({
    markdown: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.shape({
      ...imageProps,
    }),
  }).isRequired,
}

const onePageHeader = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  download_filename: PropTypes.string,
  thumbnail_name: PropTypes.string,
}

export const validatePageYamlData = yaml => {
  if (!(process.env.NODE_ENV === "development")) {
    return
  }

  const MAX_TITLE_LENGTH = 70
  const MIN_HEADER_LENGTH = 100
  const MAX_HEADER_LENGTH = 160
  const MAX_WORD_COUNT = 700

  const titleLength = yaml.header.title.length
  const descrLength = yaml.header.description.length
  const wordCount = countWords(yaml)

  if (titleLength > MAX_TITLE_LENGTH) {
    throw new Error(
      `Title has length ${titleLength}. Should be no more than ${MAX_TITLE_LENGTH}`
    )
  }

  if (descrLength <= MIN_HEADER_LENGTH) {
    throw new Error(
      `Description has length ${descrLength}. Should be at least ${MIN_HEADER_LENGTH}`
    )
  }

  if (descrLength > MAX_HEADER_LENGTH) {
    throw new Error(
      `Description has length ${descrLength}. Should be no more than ${MAX_HEADER_LENGTH}`
    )
  }

  if (wordCount > MAX_WORD_COUNT) {
    throw new Error(
      `One pager has ${wordCount} words. Should be no more than ${MAX_WORD_COUNT}`
    )
  }

  PropTypes.checkPropTypes(onePageHeader, yaml.header, "prop", "OnePageData")
}

export const countWords = yaml => {
  const includedFields = ["title", "subtitle", "markdown"]
  const excludedWords = ["*", "\n"]

  let result = []
  unpackObject(yaml)
  return result.length

  function unpackObject(obj) {
    Object.keys(obj).forEach(key => {
      if (typeof obj[key] === "object") {
        unpackObject(obj[key])
      } else if (typeof obj[key] === "string") {
        if (includedFields.includes(key)) {
          const words = obj[key].split(" ")
          words.forEach(function (word, index) {
            if (!excludedWords.includes(word)) {
              result.push(word)
            }
          })
        }
      } else if (typeof obj[key] === "number") {
        // skip
      } else if (typeof obj[key] === "boolean") {
        // skip
      } else {
        throw new Error(`Some other type of object found: ${typeof obj[key]}`)
      }
    })
  }
}
